<template>
    <!-- Start Main Content -->
    <div v-show="!isBarcodePrint" class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Product List (Stock)</h2>
             <!-- <button type="reset" @click="printBarcode" class="btn b-light btn-danger-light btn-sm">Barcode</button> -->
        </div>

        <div class="card p-4 mb-4">
            
                <div class="flex flex-col lg:flex-row lg:items-center lg:space-x-4 space-y-4 lg:space-y-0">


                        <!-- Branch Filter -->
                        <div class="w-full lg:w-auto ml-12"   >
                            <label for="vend_name" class="block text-sm font-medium text-gray-700">Search Branch (Stock != 0 Only) </label>
                            <select class="form-input w-full p-2 border border-gray-300 rounded" id="branch_name" ref="BranchName" v-model="sale.branchname">
                                <option value=""></option>
                                <option value="0">ALL</option>
                                <option v-for="(item, index) in branchList" :key="index" :value="item.id">{{ item.name }}</option>
                            </select>
                        </div>

                    </div>

                    <div class="card p-4 mb-5"  >
                        <label for="stockFile" class="block text-sm font-medium text-gray-700">Upload CSV File</label>
                        <div class="flex items-center space-x-2">
                            <input type="file" id="stockFile" @change="onFileChange" accept=".xlsx, .xls, .csv" class="form-input p-2 border border-gray-300 rounded">
                            <button type="button" class="btn b-solid btn-primary-solid" id="importBtn" @click="uploadFile">
                                Import
                            </button>
                    
                            <div v-if="uploadProgress !== null" style="margin-top: 20px;">
                                <div style="width: 100%; background: #f0f0f0; border-radius: 5px;">
                                    <div :style="{ width: uploadProgress + '%', background: '#4caf50', height: '20px', borderRadius: '5px' }"></div>
                                </div>
                                <p>{{ uploadProgress }}%</p>
                            </div>
                    
                            <p v-if="uploadError" style="color: red;">{{ uploadError }}</p>
                        </div>
                    </div>
                    
                    

                  
                    
                    </div>
                    <!-- Loading Spinner -->
                    <div v-if="isLoading" class="flex justify-center items-center h-32">
                        <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Data is Loading...</span>
                        </div>
                    </div>


                    <div class="w-full lg:w-auto lg:ml-2 mt-4 mb-2 ml-2">
                       
                    </div>
            
                    <div class="card">
                        <!-- Static heading -->
                        <div id="printable-content">
                            <h1 class="print-only" style="text-align: center;">Zambre Patil Prayog Parivar</h1>
                            <h1 class="print-only" style="text-align: center;">Product List {{current_branch_name}}</h1>
                        </div>
        
                        <button
                            type="reset"
                            @click="printReceipt"
                            class="btn b-light btn-danger-light btn-sm"
                        >
                            Print
                        </button>
                         <button @click="exportToExcel" class=" btn-primary-solid px-5 mt-2 lg:mt-6 cursor-pointer  btn-sm">
                            Export
                        </button>
                        
                        </div>
        

        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                        <!-- <input type="file" name="stockFile" @change="onFileChange" accept=".xlsx, .xls" /> -->
                        <table v-if="stockSummary.length > 0">
                            <thead>
                              <tr>
                                <th v-for="(header, index) in stockSummary[0]" :key="index">{{ header }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, rowIndex) in stockSummary.slice(1)" :key="rowIndex">
                                <td v-for="(cell, cellIndex) in row" :key="cellIndex">{{ cell }}</td>
                              </tr>
                            </tbody>
                          </table>
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <!-- <th class="bg-[#B2E8D9]">Checkbox</th> -->
                                    <!-- <th class="bg-[#B2E8D9]">Product Category</th> -->
                                    <!-- <th class="bg-[#B2E8D9]">Entry Date</th> -->
                                    <th class="bg-[#B2E8D9]">Sr</th>
                                    <th class="bg-[#B2E8D9]">ID</th>                                    
                                    <!--<th class="bg-[#B2E8D9]">Branch <br> Name</th>-->
                                    <th class="bg-[#B2E8D9]">Product <br> Category</th>
                                    <th class="bg-[#B2E8D9]">Product <br> Name</th>
                                    <!--<th class="bg-[#B2E8D9]">Unit<br>Size</th>-->
                                    <th class="bg-[#B2E8D9]">Unit</th>
                                    <th class="bg-[#B2E8D9]">Content</th>
                                    <th class="bg-[#B2E8D9]">Description</th>
                                    <!--<th class="bg-[#B2E8D9]">Batch<br>No</th>-->
                                    <!-- <th class="bg-[#B2E8D9]">Mfg<br>Date</th>
                                    <th class="bg-[#B2E8D9]">Exp<br>Date</th> -->
                                    <!--<th class="bg-[#B2E8D9]">Product<br>Location</th>-->
                                    <th class="bg-[#B2E8D9]">Opening <br> Stock <br> (qty)</th>
                                    <!--<th class="bg-[#B2E8D9]">Total <br> Opening<br> Stock<br> (Ltr)/(Kg)</th>-->
                                    <th class="bg-[#B2E8D9]">Purchase <br> Stock <br> (qty)</th>
                                    <th class="bg-[#B2E8D9]">Transfered <br> Stock <br> (qty)</th>
                                    <!--<th class="bg-[#B2E8D9]">Total <br> Purchase <br> Stock  </th>-->
                                    <!--<th class="bg-[#B2E8D9]">Purchase <br> Rate</th>-->
                                    <th class="bg-[#B2E8D9]">Consumption <br> Stock</th>
                                    <th class="bg-[#B2E8D9]">Corrected <br> Stock</th>
                                    <th class="bg-[#B2E8D9]">Closing <br> Stock</th>
                                    <!--<th class="bg-[#B2E8D9]">Purchase <br> Amount</th>-->
                                    <th class="bg-[#B2E8D9]">Closing <br> Stock <br> Amount</th>
                                    <!--<th class="bg-[#B2E8D9]">Total <br> Opening <br> Purchase <br> - (consumption) <br> Stock</th>-->
                                    <th class="bg-[#B2E8D9]">Action</th>

                                    <!-- <th class="bg-[#B2E8D9]">Manufacturing Rate</th>
                                    <th class="bg-[#B2E8D9]">Expiry Date</th>
                                    <th class="bg-[#B2E8D9]">Batch No</th>
                                    <th class="bg-[#B2E8D9]">Quantity</th> -->
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in productsList" :key="item.id">
                                    <!-- <td><input type="checkbox" @click="barcode_select(item)"/></td> -->


                                    <!-- <td>{{item.productid}}</td> -->
                                    <!-- <td>{{ new Date(item.iddate).toISOString().split('T')[0] }}</td> -->
                                    <td>{{index+1}}</td>
                                    <td>{{item.id}}</td>
                                    <!--<td>{{item.branch_name}}</td>-->
                                    <td >{{item.Prdcat}}</td>
                                    <td  @click="getFullReport(item.id)">{{item.name}}</td>
                                    <!--<td>{{item.unitsize}}</td>-->
                                    <td>{{item.unit}}</td>          
                                    <td>{{item.content}}</td>
                                    <td>{{item.description}}</td>
                                    <!--<td>{{item.batchno}}</td>-->
                                    <!-- <td>{{item.manufacturingdate}}</td>
                                    <td>{{item.expirydate}}</td> -->
                                    <!--<td>{{item.prdlocation}}</td>-->
                                    <td>{{item.openingstock}}</td>
                                    <!--<td>{{item.unitsize * item.openingstock}}</td>-->
                                    <td>{{parseFloat(item.totalPurchasedStock).toFixed(2)}}</td>
                                    <td>{{parseFloat(item.totalTransferStock).toFixed(2)}}</td>
                                    <!--<td>{{item.unitsize * item.totalPurchasedStock}}</td>-->
                                    <!--<td>{{item.purchaserate}}</td>-->
                                  
                                  
                                    <td>{{parseFloat(item.totalConsumedStock).toFixed(2)}}</td>
                                    <td>{{parseFloat(item.correctedStock).toFixed(2)}}</td>
                                    <td>{{ ((parseFloat(item.totalTransferStock||0)+parseFloat(item.openingstock||0)+parseFloat(item.totalPurchasedStock||0)+parseFloat(item.correctedStock||0)) - parseFloat(item.totalConsumedStock||0)).toFixed(2)  }}</td>

                                    <!--<td>{{ (parseFloat(item.totalPurchasedStock||0) * parseFloat(item.purchaserate||0))}}</td>-->

                                    <td>{{ parseFloat(item.total_stock_amount).toFixed(2)}}</td>

                                    <!--<td>{{ item.unitsize * item.openingstock + item.unitsize * item.totalPurchasedStock - item.totalConsumedStock}}</td>-->



                                    <td class="px-3.5 py-4">
                                        <div class="flex items-center gap-1">

                                            <button class="btn-icon btn-primary-icon-light size-7"  @click="editModal(item)"  >
                                                <i class="ri-edit-2-line text-inherit text-[13px]"></i>
                                            </button>

                                            <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" >
                                                <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                            </button>
                                        </div>
                                    </td>
                                    <!-- <td>{{item.manufacturingdate}}</td>
                                    <td>{{item.expirydate}}</td>
                                    <td>{{item.batchno}}</td>
                                    <td>{{item.openingstock}}</td>
                                    <td>{{item.totalqty}}</td> -->

                                </tr> 
                            </tbody>
                            <!--<tfoot>-->
                            <!--    <tr>-->
                            <!--      <td colspan="10" class="font-bold text-right">Total:</td>  -->
                            <!--      <td class="font-bold">{{ openingstock }}</td>-->
                            <!--      <td class="font-bold">{{ totalopeningstocks }}</td>-->
                            <!--      <td class="font-bold">{{ totalpurchasetocks }}</td>-->
                            <!--      <td class="font-bold">{{ completepurchasetocks }}</td>-->
                            <!--      <td class="font-bold">{{ purchaserate }}</td>-->
                            <!--      <td class="font-bold">{{ consumption }}</td>-->
                            <!--      <td class="font-bold">{{ closingstock }}</td>-->
                            <!--      <td class="font-bold">{{ purchaseamount }}</td>-->
                            <!--      <td class="font-bold">{{ openingstockamount }}</td>-->
                            <!--      <td class="font-bold">{{ totalopeningpurchase }}</td>-->
                       
                            <!--    </tr>-->
                            <!--  </tfoot>-->
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->


<!-- Start Edit Modal -->
<div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="background: #00000052;">
    <div class="p-4 w-full max-w-lg max-h-full overflow-y-auto">
        <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
            <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                <i class="ri-close-line text-inherit text-xl leading-none"></i>
            </button>
            <div class="p-4 md:p-5">
                <div class="mt-7">
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label class="form-label">Type *</label>
                        <select class="form-input" v-model="product.prodcatid">
                            <option DISABLED value="0">SELECT CATEGORY</option>
                            <option v-for="(item, index) in catList" :value="item.id">{{ item.name }}</option>
                        </select>
                    </div>
                </div>

                <!-- Side by side input fields -->
                <div class="mt-7 flex space-x-4">
                    <div class="w-full md:w-1/2">
                        <label for="tagname" class="form-label">Branch Name*</label>
                        <select v-model="product.branchid" class="form-input">
                            <option v-for="(item, index) in branchList" :key="index" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                    </div>

                    <div class="w-full md:w-1/2">
                        <label for="tagname" class="form-label">Unit*</label>
                        <select class="form-input" name="status" v-model="product.unit">
                            <option value="">Choose Unit</option>
                            <option value="KG">KG</option>
                            <option value="LTR">LTR</option>
                        </select>
                    </div>
                </div>
                <div class="mt-7 flex space-x-4">
                <div class="w-full md:w-1/2">
                    <label for="" class="form-label">Name *</label>
                    <input type="text" v-model="product.name" placeholder="Type Here" class="form-input" required autocomplete="off">
                </div>

                <div class="w-full md:w-1/2">
                    <label for="" class="form-label">Content *</label>
                    <input type="text" v-model="product.content" placeholder="Type Here" class="form-input" required autocomplete="off">
                </div>
                </div>
                <div class="mt-7 flex space-x-4">
                <div class="w-full md:w-1/2">
                    <label for="" class="form-label">Description *</label>
                    <input type="text" v-model="product.description" placeholder="Type Here" class="form-input" required autocomplete="off">
                </div>

                <div class="w-full md:w-1/2">
                    <label for="" class="form-label">Unit Size *</label>
                    <input type="text" v-model="product.unitsize" placeholder="Type Here" class="form-input" required autocomplete="off">
                </div>
                </div>
                <div class="mt-7 flex space-x-4">
                <div class="w-full md:w-1/2">
                    <label for="" class="form-label">Purchase Rate *</label>
                    <input type="number" v-model="product.purchaserate" placeholder="Type Here" class="form-input" required autocomplete="off">
                </div>

                <div class="w-full md:w-1/2">
                    <label for="" class="form-label">Batch No *</label>
                    <input type="text" v-model="product.batchno" placeholder="Type Here" class="form-input" required autocomplete="off">
                </div>
                </div>
                <div class="mt-7 flex space-x-4">
                <div class="w-full md:w-1/2">
                    <label for="" class="form-label">Manufacturing Date *</label>
                    <input type="date" v-model="product.manufacturingdate" placeholder="Type Here" class="form-input" required autocomplete="off">
                </div>

                <div class="w-full md:w-1/2">
                    <label for="" class="form-label">Expiry Date *</label>
                    <input type="date" v-model="product.expirydate" placeholder="Type Here" class="form-input" required autocomplete="off">
                </div>
                </div>
                <div class="mt-7 flex space-x-4">
                <div class="w-full md:w-1/2">
                    <label for="" class="form-label">Opening Stock *</label>
                    <input type="number" v-model="product.quantity" placeholder="Type Here" class="form-input" required autocomplete="off">
                </div>

                <div class="w-full md:w-1/2">
                    <label for="" class="form-label">Product Location *</label>
                    <input type="text" v-model="product.prdlocation" placeholder="Type Here" class="form-input" required autocomplete="off">
                </div>
                </div>
                <div class="mt-7 flex space-x-4">
                <div class="w-full md:w-1/2">
                    <label for="" class="form-label">HSN *</label>
                    <input type="text" v-model="product.hsn" placeholder="Type Here" class="form-input" required autocomplete="off">
                </div>

                <div class="w-full md:w-1/2">
                    <label for="" class="form-label">GST*</label>
                    <input type="text" v-model="product.gst" placeholder="Type Here" class="form-input" required autocomplete="off">
                </div>
                </div>

                <div class="flex justify-end mt-7">
                    <button @click="save_category" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                </div>
            </div>
        </div>
    </div>
</div>



<!-- End Edit Modal -->




       <!-- Start Delete Modal -->
       
    <BarcodeComp :GetproductsList="productsList" v-if='isBarcodePrint' @hideprintBarcode="printBarcode"/> 
       
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
    
    
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';
import BarcodeComp from '@/components/BarcodeComp.vue'

export default {
name: 'AddProduct',
components: {
 BarcodeComp
} ,
mounted(){
 this.getBasics();
},
watch: {
         productsList () { // data used in the table
           this.$nextTick (() => { // wait until data fully updated before re-render new DOM 
             $('.datatable').DataTable().draw();
           })
         },
     },
data() {
 return {
    file: null,
    uploadProgress: null,
    uploadError: null,
    stockSummary: null,
     isBarcodePrint:false,
     stockSummary: [], // Holds the parsed Excel data
      file: null ,
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
     productsList:[],
     original_productsList:[],
     catList:[],
     branchlist:[],
     isLoading: false, // Flag for loading spinner
     datatable:null,
    //  product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
   // product:{productid:'',manufacturingdate:'',expirydate:'',batchno:'',openingstock:'',quantity:''},
   product: { 
    prodcatid:'',name: '', content:'',description:'',purchaserate:'',manufacturingdate:'',expirydate:'',batchno:'',quantity:'',hsn:'',gst:'',unit:'',branchid:'',unitsize:'',prdlocation:''},
   products:{name:'',content:'',description:'',purchaserate:''},
     employees: {empname:'',emprole:'0',isMainAdmin:0},
     sale:{
       branchname:null,
      },
      current_branch_name:'',
 }
 }, 



 computed: {
    openingstock() {
        return this.productsList.reduce((total, item) => total + (parseFloat(item.openingstock) || 0), 0);
},


    totalopeningstocks() {
        return (this.productsList || []).reduce(
            (total, item) => total + (item.unitsize  || 0) * (item.openingstock || 0),
            0
        );
    },
   
     totalpurchasetocks() {
            return this.productsList.reduce((total, item) => total + (parseFloat(item.totalPurchasedStock) || 0), 0);
    },
  
        completepurchasetocks() {
            return (this.productsList || []).reduce(
                    (total, item) => total + (item.unitsize || 0) * (item.totalPurchasedStock || 0),
                    0
                );

        },

    purchaserate() {
        return this.productsList.reduce((total, item) => total + (parseFloat(item.purchaserate) || 0), 0);
    },

    consumption() {
        return this.productsList.reduce((total, item) => total + (parseFloat(item.totalConsumedStock) || 0), 0);
    },

    closingstock() {
    return (this.productsList || []).reduce(
        (total, item) => {
            const openingStock = Number(item.openingstock) || 0;
            const totalPurchasedStock = Number(item.totalPurchasedStock) || 0;
            const totalConsumedStock = Number(item.totalConsumedStock) || 0;
            return total + openingStock + totalPurchasedStock - totalConsumedStock;
        },
        0
    );
},


    purchaseamount() {
            return (this.productsList || []).reduce(
                (total, item) => total + (item.totalPurchasedStock || 0) * (item.purchaserate || 0),
                0
            );
        },

        openingstockamount() {
            return (this.productsList || []).reduce(
                (total, item) => total + (item.openingstock || 0) * (item.purchaserate || 0),
                0
            );
        },
 


        totalopeningpurchase() {
            return (this.productsList || []).reduce(
                (total, item) => total + (item.unitsize || 0) * (item.openingstock  || 0) + (item.unitsize  || 0) *(item.totalPurchasedStock || 0) - (item.totalConsumedStock || 0),
                0
            );
        },


},



methods:{
    getFullReport(id) {
            window.open('/productFullReport?q=' + id, '_blank');
        },
        
    async uploadFile() {
    if (!this.file) {
        this.$refs.progress.value = 0; // Reset progress
        alert('Please select a file first.');
        return;
    }

    const formData = new FormData();
    formData.append('stockFile', this.file);

    try {
        // Initialize progress state
        
        this.uploadProgress = 0;

        const { data } = await axios.post('uploadFile', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
                if (progressEvent.lengthComputable) {
                    const percentComplete = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    this.uploadProgress = percentComplete;
                    //alert(this.uploadProgress);
                  //  location.reload();
                }
            },
        });

        if (data.error) {
            this.uploadError = 'Error importing stock summary: ' + data.error;
        } else {
            this.stockSummary = data;
            this.uploadError = data;
            this.uploadProgress = 100; // Ensure progress bar completes
        }
    } catch (error) {
        this.uploadError = 'Error uploading file.';
        this.uploadProgress = 0; // Reset on failure
    }
},

printReceipt() {
            $('.datatable').DataTable().destroy(); 
             window.print();
    },



    onFileChange(event) {
      this.file = event.target.files[0];
    },
    printBarcode(){
      this.isBarcodePrint =!this.isBarcodePrint;
    },
    barcode_select(item){
        try {
            if(item.checked)
                item.checked=0;
            else
                item.checked=1;
            
        } catch (e) {
            item.checked=1;
        }
    },
    exportToExcel() {
        // Prepare the CSV header
        const headers = ["name", "content", "description", "purchaserate", "totalPurchasedStock", "totalConsumedStock", "total_qty"];
        const rows = this.productsList.map(item => [
            item.name,
            item.content,
            item.description,
            item.purchaserate,
            item.totalPurchasedStock,
            item.totalConsumedStock,
            item.total_qty,
        ]);

        // Combine headers and rows into a CSV string
        const csvContent = [headers, ...rows]
            .map(row => row.map(value => `"${value}"`).join(","))
            .join("\n");

        // Create a Blob from the CSV content
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        // Trigger a download
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "productlist_report.csv");
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }, 
 closeModal(){
     
    $("#editModal").addClass('hidden');
    $("#deleteModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
 },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isAdd=!this.isAdd;
 },

 editModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.product=copy;
         this.product.quantity=copy.openingstock;
         this.product.unit=copy.unit;
         this.product.hsn=copy.hsn;
         this.product.gst=copy.gst;
         this.product.prdlocation=copy.prdlocation
         if(this.branchList.length==1){
             this.product.branchid=this.branchList[0].id;
         }
     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },
 deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
async getBasics() {
    this.isLoading = true; // Show the spinner while filtering
       var self=this;
         axios.post('getProducts').then(function (response) {
                 self.productsList=response.data.products;
                 self.catList=response.data.catlist;
                 self.branchlist=response.data.branchlist;
                 self.original_productsList = response.data.products; 
                 self.employees=response.data.userDetails;
                 self.branchList = response.data.branchLists;
                }).then(()=>{ 

                    $("#branch_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Branch Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                    //    alert(event.target.value);
                                         self.getBasicFilteredData(event.target.value); 
                                        });

              
                                    }).finally(function () {
                                        self.isLoading = false; // Hide the spinner after the request

                    });;
  }, 

  
 async getBasicFilteredData(branchid) {
    this.isLoading = true; // Show the spinner while filtering
       var self=this;
         axios.post('getProducts',{branchid,branchid}).then(function (response) {
               if ($.fn.dataTable.isDataTable('#basicDataTable')) {
                        $('#basicDataTable').DataTable().destroy();
                    }
                 self.current_branch_name=response.data.branch_name;
                 self.productsList=response.data.products;
                 self.original_productsList = response.data.products; 
                 self.employees=response.data.userDetails;
                //  self.branchList = response.data.branchLists;
                }).then(()=>{ 
                        $('#basicDataTable').DataTable();
                    // $("#branch_name").select2({
                    //                     width: '80%',
                    //                     dropdownAutoWidth : true,
                    //                     placeholder:"Search Branch Here...",
                    //                 "language": {
                    //                             "noResults": function(){
                    //                                 return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                    //                             }
                    //                         },
                    //                             escapeMarkup: function (markup) {
                    //                                 return markup;
                    //                             }
                    //                 }).on('change', function (event) {
                    //                         self.getBasicFilteredData(event.target.value); 
                    //                            $('.datatable').DataTable().destroy();
                                            
                    //                     });

                }).finally(function () {
                    self.isLoading = false; // Hide the spinner after the request

                    });;
                    
  }, 
        view_barcode(id) {
            var self = this;
            window.open(window.location.origin+'/Barcode?q='+id,'_blank');
        },
           
            delete_category() {
                var self = this; 
                axios.post('deleteProductlist', {deleteId:this.deleteId})
                    .then(response => {
                        //self.productsList=response.data.products;
                        self.getBasics(); 
                        self.closeModal(); 
                       
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },

            save_category() {
            var self = this;
                self.$swal({
                    title: "Do You Want To Save?",
                    text: "Are you sure? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed
                        axios.post('addProduct', this.product)
                            .then(response => {
                                var msg = response.data.msg;
                                var isSuccess = response.data.status;
                                self.catList = response.data.cats;
                                self.employees = response.data.userDetails;
                                self.cat = { name: '', status: 'Active' };
                                self.closeModal();
                                self.getBasics();
                                if (isSuccess == 1) {
                                    self.product = { name: '', cat: '0', barcode: '', hsn: '', descr: '', gst: '5', unit: '', mrp: '0', prate: '0', salerate: '0', set_rate: '0', set_qty: '0', op_qty: '0' };
                                    $("#barcode").focus();
                                }


                                self.$swal(msg);

                            })
                            .catch(error => {
                                console.log('Error on Authentication: ' + error);
                            });
                    }
                });


        },




}
}
</script>


<style scoped>
    tfoot{
        background: antiquewhite;
        font-size: medium;
        font-weight: 800;
    }
    tfoot td{
        height: 35px;
    }
    .print-only {
        display: none;
    }
    
    @media print {
        .print-only {
            display: block; /* Show elements for print */
            text-align: center; /* Center alignment as needed */
            font-size: 16px; /* Font size adjustments if needed */
        }
    }
    
    
    @media print {
        /* Hide unnecessary elements */
        button, select, input, h2, .header_class, .header, .card-title {
            display: none !important;
        }
        
    
        /* Adjust the layout */
        body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
        }
    
        /* Receipt container */
        .receipt-container, #printable-content {
            width: 100%;
            padding: 10mm;
            margin: auto;
            border: 1px solid #000;
        }
    
        /* Add a border and spacing to the table */
        table {
            width: 100%;
            border-collapse: collapse;
        }
    
        table th, table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
            font-size: 12px;
            color: black !important; 
        }
    
        
        table th {
            background-color: #f2f2f2;
            font-weight: bold;
            color: black!important;
        }
    
        /* Center titles */
        h1, h2 {
            text-align: center;
            margin: 0 0 10px;
            font-size: 16px;
            font-weight: bold;
        }
    
        /* Add company branding details */
        #printable-content {
            text-align: center;
        }
    
        #printable-content h1 {
            font-size: 20px;
        }
    
        /* Add spacing between sections */
        .section {
            margin-bottom: 20px;
        }
    
        /* Performance container styling */
        .performance-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }
    
        .performance-box {
            flex: 1;
            padding: 5px;
            margin: 0 5px;
            border: 1px solid #ddd;
            font-size: 12px;
            text-align: center;
        }
    
        .performance-box.best {
            background-color: #c8e6c9;
        }
    
        .performance-box.good {
            background-color: #bbdefb;
        }
    
        .performance-box.average {
            background-color: #ffe0b2;
        }
    }
    
      
        .salary_input{
            padding: 5px;
            width: 70px;
        }
        .plotname{
            font-size: x-small;
        font-weight: 200;
        background: yellow;
        padding: 0px 2px;
        border-radius: 10px;
        }
    
        .performance-container {
          display: flex;
          gap: 20px;
        }
        .performance-box {
          padding: 1px;
          border-radius: 8px;
          color: white;
          text-align: center;
          font-weight: bold;
          width: 80px;
        }
        
        .Best1 {
          background-color: green;
        }
        .Good1 {
          background-color: blue;
        }
        .Average1 {
          background-color: orange;
        }
    
        .best {
      color: green;
    }
    .good {
      color: blue;
    }
    .average {
      color: orange;
    }
    </style>
    










<style>



@media print {
    button, select, input, h2, .header_class, .header, .card-title,select,label,.select2 {
        display: none !important;
    }
    

}

    .suggestions-list{
    line-height: 16px;
    background: bisque;
    padding: 10px;
}
.suggestions-list li{
    padding-top: 5px;
    border-bottom: 0.5px solid gray;
}
</style>